import axios from 'axios';

const getURL = () => process.env.API_URL+"/api";

import Cookies from 'js-cookie';

    let intervalSend = null;
                    
    function _registerEvent(target, eventType, cb) {
        if (target.addEventListener) {
            target.addEventListener(eventType, cb);
            return {
                remove: function () {
                    target.removeEventListener(eventType, cb);
                }
            };
        } else {
            target.attachEvent(eventType, cb);
            return {
                remove: function () {
                    target.detachEvent(eventType, cb);
                }
            };
        }
    }
    
    function _createHiddenIframe(target, uri) {
        var iframe = document.createElement("iframe");
        iframe.src = uri;
        iframe.id = "hiddenIframe";
        iframe.style.display = "none";
        target.appendChild(iframe);
    
        return iframe;
    }
    
    function openUriWithHiddenFrame(uri, failCb, successCb) {
        var timeout = setTimeout(function () {
            failCb();
            handler.remove();
        }, 1000);
    
        var iframe = document.querySelector("#hiddenIframe");
        if (!iframe) {
            iframe = _createHiddenIframe(document.body, "about:blank");
        }
    
        var handler = _registerEvent(window, "blur", onBlur);
    
        function onBlur() {
            clearTimeout(timeout);
            handler.remove();
            successCb();
        }
    
        iframe.contentWindow.location.href = uri;
    }
   
    function openUriWithTimeoutHack(uri, failCb, successCb) {
        var timeout = setTimeout(function () {
            failCb();
            handler.remove();
        }, 1700);
    
        //handle page running in an iframe (blur must be registered with top level window)
        var target = window;
        while (target != target.parent) {
            target = target.parent;
        }
    
        var handler = _registerEvent(target, "blur", onBlur);
    
        function onBlur() {
            clearTimeout(timeout);
            handler.remove();
            successCb();
        }
    
        window.location = uri;
    }
    function openUriWithTimeoutHackForSafary(uri, failCb, successCb) {
        var timeout = setTimeout(function () {
            failCb();
            handler.remove();
        }, 2000);
    
        //handle page running in an iframe (blur must be registered with top level window)
        var target = window;
        while (target != target.parent) {
            target = target.parent;
        }
    
        var handler = _registerEvent(target, "blur", onBlur);
    
        function onBlur() {
            clearTimeout(timeout);
            handler.remove();
            successCb();
        }
        var iframe = document.querySelector("#hiddenIframe");
    
        if (!iframe)
            iframe = _createHiddenIframe(document.body, "about:blank");
    
        iframe.contentWindow.location.href = uri;
    }
    
    function openUriUsingFirefox(uri, failCb, successCb) {
        var iframe = document.querySelector("#hiddenIframe");
    
        if (!iframe) {
            iframe = _createHiddenIframe(document.body, "about:blank");
        }
    
        var combineAbrochForFf = setTimeout(function(){
            openUriWithTimeoutHack(uri, failCb, successCb); //fixed bug in detect of Toustart Transfer
        }, 300);
        try {
            iframe.contentWindow.location.href = uri;
            clearTimeout(combineAbrochForFf);
            successCb();
        } catch (e) {
            if (e.name == "NS_ERROR_UNKNOWN_PROTOCOL" || e.name == 'NS_ERROR_FAILURE') {
                clearTimeout(combineAbrochForFf);
                failCb();
            }
        }
    }
    

    
    function openUriUsingIE10InWindows7(uri, failCb, successCb) {
        var timeout = setTimeout(failCb, 1000);
        window.addEventListener("blur", function () {
            clearTimeout(timeout);
            successCb();
        });
    
        var iframe = document.querySelector("#hiddenIframe");
        if (!iframe) {
            iframe = _createHiddenIframe(document.body, "about:blank");
        }
        try {
            iframe.contentWindow.location.href = uri;
        } catch (e) {
            failCb();
            clearTimeout(timeout);
        }
    }
    
    function openUriInNewWindowHack(uri, failCb, successCb) {
        var myWindow = window.open('', '', 'width=0,height=0');
    
        myWindow.document.write("<iframe src='" + uri + "'></iframe>");
    
        setTimeout(function () {
            try {
                myWindow.location.href;
                myWindow.setTimeout("window.close()", 1000);
                successCb();
            } catch (e) {
                myWindow.close();
                failCb();
            }
        }, 1000);
    }
    
    function openUriWithMsLaunchUri(uri, failCb, successCb) {
    //    if(navigator.appName == "Netscape" && navigator.appVersion.indexOf('Edge') > -1){
    //        console.log('Edge');
    //        function successCallback() {
    //            successCb && successCb();
    //        }
    //        openUriInEdge(uri, failCb, successCallback);
    //    }else{
    console.log('msLaunchUri', uri);
            navigator.msLaunchUri(uri,
                successCb,
                failCb
            );
    //    }
    }
    
    function checkBrowser() {
        var isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
        return {
            isOpera   : isOpera,
            isFirefox : typeof InstallTrigger !== 'undefined',
            isSafari  : Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0,
            isChrome  : !!window.chrome && !isOpera,
            isIE      : /*@cc_on!@*/false || !!document.documentMode // At least IE6
        }
    }
    
    function getInternetExplorerVersion() {
        var rv = -1;
        if (navigator.appName === "Microsoft Internet Explorer") {
            var ua = navigator.userAgent;
            var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) != null)
                rv = parseFloat(RegExp.$1);
        }
        else if (navigator.appName === "Netscape") {
            var ua = navigator.userAgent;
            var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) != null) {
                rv = parseFloat(RegExp.$1);
            }
        }
        return rv;
    }

    function showCostumUpdateLink(keyTT) {
            jQuery.getJSON(
                '/ajax/gps/isExistsTT/',
                {
                    keytt: keyTT
                },
                function(data)
                {
                    if(data.code == 200)
                        if(!data.body || (data.body && data.body.length < 5))
                            jQuery.gps.costumUpdateTourstartTransfer();
                }
            );    
    }

    function goToLaunchTT( hreff, failCb ) {
            if(typeof InstallTrigger !== 'undefined'){
                var iframe = document.querySelector("#hiddenIframe");
    
                if (!iframe)
                    iframe = _createHiddenIframe(document.body, "about:blank");
    
                try {
                    iframe.contentWindow.location.href = hreff;
                    window.location.href = hreff;
                } catch (e) {
                    if (e.name == "NS_ERROR_UNKNOWN_PROTOCOL") {
                            clearInterval(intervalSend);
                            failCb();
                    }
                }
            }else{
                window.location.href = hreff;
            }
    }
    
     function detectTourstartTransfer(ident, hreff, failCb) {
    
        const keyTT = Cookies.get('transferTourstartOn');

        if(keyTT){
            axios({
                url: `${getURL()}/gps.isExistsTT?keytt=${keyTT}`,
                method: 'GET',
                withCredentials: true
            }).then(res => {
                const {code, response} = res;
                if(code != 200){
                    Cookies.set('transferTourstartOn', '',{ expires: 365, path: '/' });   
                    failCb();             
                }else if(!response || (response && response.length < 5)){
                }
                goToLaunchTT( hreff, failCb );
                })
        }else{
            const limitAjax = 15;
            let count = 1;
            intervalSend = setInterval(function(){
                count++;
                axios({
                    url: `${getURL()}/gps.checkIdent?ident=${ident}`,
                    method: 'GET',
                    withCredentials: true
                })
                .then(res => {
                    const {code, response} = res;
                    if(count>limitAjax){
                        clearInterval(intervalSend);
                        failCb();
                    }
                    if(code == 200 && response){
                        clearInterval(intervalSend);
                        Cookies.set('transferTourstartOn', response,{ expires: 365, path: '/' });   
                    }
                })
            }, 200);
                goToLaunchTT( hreff, failCb );                                  
        }
    }
  
         

export const customProtocolCheck = (uri, failCb, successCb) => {
        function failCallback() {
            failCb && failCb();
        }
    
        function successCallback() {
            successCb && successCb();
        }
        

        var indentifyArr = uri.split(':');
        var ident = indentifyArr[1];
        var mac = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;
        var ua = navigator.userAgent.toLowerCase(); 
        
        // if (mac) {
            const browser = checkBrowser();

            if (browser.isFirefox) {
                // console.log('browser.isFirefox');
                openUriUsingFirefox(uri, failCallback, successCallback);
            } else if (browser.isChrome || browser.isOpera) {
                // console.log('browser.isChrome || browser.isOpera');
                openUriWithTimeoutHack(uri, failCallback, successCallback);
            } else if (ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1) {
                // console.log("ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1");
                openUriWithTimeoutHackForSafary(uri, failCallback, successCallback);
            } else if (browser.isIE) {
                openUriUsingIEInOlderWindows(uri, failCallback, successCallback);
            }else{
                // console.log('other browsers');
                openUriWithTimeoutHack(uri, failCallback, successCallback);
            }               
        // }else{
        //     goToLaunchTT( uri, failCb );
            // detectTourstartTransfer(ident, uri, failCb);      
        // }
    }

// function _registerEvent(target, eventType, cb) {
//     if (target.addEventListener) {
//         target.addEventListener(eventType, cb);
//         return {
//             remove: function () {
//                 target.removeEventListener(eventType, cb);
//             }
//         };
//     } else {
//         target.attachEvent(eventType, cb);
//         return {
//             remove: function () {
//                 target.detachEvent(eventType, cb);
//             }
//         };
//     }
// }

// function _createHiddenIframe(target, uri) {
//     var iframe = document.createElement("iframe");
//     iframe.src = uri;
//     iframe.id = "hiddenIframe";
//     iframe.style.display = "none";
//     target.appendChild(iframe);

//     return iframe;
// }



// function openUriWithHiddenFrame(uri, failCb, successCb) {

//     var timeout = setTimeout(function () {
//         failCb();
//         handler.remove();
//     }, 1000);

//     var iframe = document.querySelector("#hiddenIframe");
//     if (!iframe) {
//         iframe = _createHiddenIframe(document.body, "about:blank");
//     }

//     var handler = _registerEvent(window, "blur", onBlur);

//     function onBlur() {
//         clearTimeout(timeout);
//         handler.remove();
//         successCb();
//     }

//     iframe.contentWindow.location.href = uri;
// }

// function openUriWithTimeoutHack(uri, failCb, successCb) {
    
//     var timeout = setTimeout(function () {
//         failCb();
//         handler.remove();
//     }, 1000);

//     //handle page running in an iframe (blur must be registered with top level window)
//     var target = window;
//     while (target != target.parent) {
//         target = target.parent;
//     }

//     var handler = _registerEvent(target, "blur", onBlur);

//     function onBlur() {
//         clearTimeout(timeout);
//         handler.remove();
//         successCb();
//     }

//     window.location = uri;
// }

// function openUriUsingFirefox(uri, failCb, successCb) {
//     var iframe = document.querySelector("#hiddenIframe");

//     if (!iframe) {
//         iframe = _createHiddenIframe(document.body, "about:blank");
//     }

//     try {
//         iframe.contentWindow.location.href = uri;
//         successCb();
//     } catch (e) {
//         if (e.name == "NS_ERROR_UNKNOWN_PROTOCOL") {
//             failCb();
//         }
//     }
// }

function openUriUsingIEInOlderWindows(uri, failCb, successCb) {
    if (getInternetExplorerVersion() === 10) {
        openUriUsingIE10InWindows7(uri, failCb, successCb);
    } else if (getInternetExplorerVersion() === 9 || getInternetExplorerVersion() === 11) {
        openUriWithHiddenFrame(uri, failCb, successCb);
    } else {
        openUriInNewWindowHack(uri, failCb, successCb);
    }
}

// function openUriUsingIE10InWindows7(uri, failCb, successCb) {
//     var timeout = setTimeout(failCb, 1000);
//     window.addEventListener("blur", function () {
//         clearTimeout(timeout);
//         successCb();
//     });

//     var iframe = document.querySelector("#hiddenIframe");
//     if (!iframe) {
//         iframe = _createHiddenIframe(document.body, "about:blank");
//     }
//     try {
//         iframe.contentWindow.location.href = uri;
//     } catch (e) {
//         failCb();
//         clearTimeout(timeout);
//     }
// }

// function openUriInNewWindowHack(uri, failCb, successCb) {
//     var myWindow = window.open('', '', 'width=0,height=0');

//     myWindow.document.write("<iframe src='" + uri + "'></iframe>");

//     setTimeout(function () {
//         try {
//             myWindow.location.href;
//             myWindow.setTimeout("window.close()", 1000);
//             successCb();
//         } catch (e) {
//             myWindow.close();
//             failCb();
//         }
//     }, 1000);
// }

// function openUriWithMsLaunchUri(uri, failCb, successCb) {
//     navigator.msLaunchUri(uri,
//         successCb,
//         failCb
//     );
// }



// function checkBrowser() {
//     const isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
//     const ua = navigator.userAgent.toLowerCase();
//     return {
//         isOpera   : isOpera,
//         isFirefox : typeof InstallTrigger !== 'undefined',
//         isSafari  : (~ua.indexOf('safari') && !~ua.indexOf('chrome')) || Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0,
//         isIOS     : /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
//         isChrome  : !!window.chrome && !isOpera,
//         isIE      : /*@cc_on!@*/false || !!document.documentMode // At least IE6
//     }
// }



// function getInternetExplorerVersion() {
//     var rv = -1;
//     if (navigator.appName === "Microsoft Internet Explorer") {
//         var ua = navigator.userAgent;
//         var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
//         if (re.exec(ua) != null)
//             rv = parseFloat(RegExp.$1);
//     }
//     else if (navigator.appName === "Netscape") {
//         var ua = navigator.userAgent;
//         var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
//         if (re.exec(ua) != null) {
//             rv = parseFloat(RegExp.$1);
//         }
//     }
//     return rv;
// }


// export const customProtocolCheck = (uri, failCb, successCb, unsupportedCb) => {
//     function failCallback() {
//         failCb && failCb();
//     }

//     function successCallback() {
//         successCb && successCb();
//     }

//     if (navigator.msLaunchUri) { //for IE and Edge in Win 8 and Win 10
//         openUriWithMsLaunchUri(uri, failCb, successCb);
//     } else {
//         const browser = checkBrowser();

//         if (browser.isFirefox) {
//             openUriUsingFirefox(uri, failCallback, successCallback);
//         } else if (browser.isChrome || browser.isIOS) {
//             openUriWithTimeoutHack(uri, failCallback, successCallback);
//         } else if (browser.isIE) {
//             openUriUsingIEInOlderWindows(uri, failCallback, successCallback);
//         } else if (browser.isSafari) {
//             openUriWithHiddenFrame(uri, failCallback, successCallback);
//         } else {
//             unsupportedCb();
//         }
//     }
// }